import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import CustomerShippingRatesIndexPage from '../containers/CustomerShippingRates'
import BasketSizeRatesDetailPage from '../containers/CustomerShippingRates/BasketSizeRatesDetail'
import { CUSTOMER_SHIPPING_RATE_ROLES } from '../containers/CustomerShippingRates/graphql'
import { withAuthorization } from '../containers/Authorization'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const CustomerShippingRatesIndex = withAuthorization(CustomerShippingRatesIndexPage, CUSTOMER_SHIPPING_RATE_ROLES)
const BasketSizeRatesDetail = withAuthorization(BasketSizeRatesDetailPage, CUSTOMER_SHIPPING_RATE_ROLES)

const CustomerShippingRatesPage = ({ location, match }) => {
  const dispatch = useDispatch()
  const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
  const { pathname } = location

  useEffect(() => {
    if (current[0] !== 'customer_shipping_rates') {
      dispatch(changeCurrent(['customer_shipping_rates']))
    }
  }, [pathname])

  const path = match.url

  return (
    <Switch>
      <Route path={`${path}/basket_size/:provinceId`} component={BasketSizeRatesDetail} exact />
      <Route path={`${path}/:tab(full_truck_load)?`} component={CustomerShippingRatesIndex} exact />
      <Redirect to={path} />
    </Switch>
  )
}

CustomerShippingRatesPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

CustomerShippingRatesPage.defaultProps = {}

export default CustomerShippingRatesPage
